import {Workbook} from 'exceljs';

export const workbook = new Workbook();
